import { render, staticRenderFns } from "./GeneralContainer.vue?vue&type=template&id=c19999e0"
import script from "./GeneralContainer.vue?vue&type=script&lang=js"
export * from "./GeneralContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports